import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { FVFunil } from '../models/fvfunil';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class FVFunilService {
  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarFunis() {
    return this.http.get<FVFunil[]>(globals.apiUrl + '/api/FVFunil/Lista');
  }
}
